export const FAQ_DATA = [
  {
    id: 1,
    title: '주문 및 배송',
    faqs: [
      {
        id: 1,
        question: '주문 취소는 어떻게 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 회원 주문 건의 경우 로그인 &gt; 마이페이지 &gt; 전체 주문 내역 &gt; 상품 체크 &gt; 상단 전체 주문 취소 &gt; 하단 주문 취소</p>
        <p><span style="font-size: 10px;">●</span> 비회원 주문 건의 경우 비회원 주문조회 로그인 &gt; 상품 체크 &gt; 상단 전체 주문 취소 &gt; 하단 주문 취소</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 상품 이관 상태에 따라 주문 취소가 불가할 수 있습니다.</p>
        `,
      },
      {
        id: 2,
        question: '배송지 변경은 어떻게 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 회원 주문 건의 경우 로그인 &gt; 마이페이지 &gt; 전체 주문 내역 &gt; 배송지 변경 &gt; 저장</p>
        <p><span style="font-size: 10px;">●</span> 비회원 주문 건의 경우 비회원 주문조회 로그인 &gt; 배송지 변경 &gt; 저장</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 배송 상태가 상품 준비 중일 경우 상품 이관 상태에 따라 배송지 변경이 불가할 수 있습니다.</p>
        `,
      },
      {
        id: 3,
        question: '배송 추적은 어디서 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 회원 주문 건의 경우 로그인 &gt; 마이페이지 &gt; 전체 주문 내역에서 송장번호 확인이 가능합니다.</p>
        <p><span style="font-size: 10px;">●</span> 비회원 주문 건의 경우 비회원 주문 조회 로그인하시면 송장번호 확인이 가능합니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 배송 상태가 배송 중일 경우 송장번호로 확인이 가능합니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 송장번호 흐름 확인의 경우 택배사로 상품이 전달된 다음날 흐름이 확인될 수 있습니다.</p>
        `,
      },
      {
        id: 4,
        question: '결제 수단은 어떤 방법이 있나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 실시간 계좌이체 / 신용카드 / 카카오페이 / 네이버페이 / 적립금으로 결제가 가능합니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 주문/결제 완료 이후에는 결제 수단 변경이 불가합니다.</p>
        `,
      },
      {
        id: 5,
        question: '배송은 언제 출고되나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 평일 오후 2시 이전 결제 완료된 주문 건에 한하여 당일 출고됩니다.</p>
        <p><span style="font-size: 10px;">●</span> 제품 수령의 경우 택배사 상황에 따라 1~3일 정도 소요됩니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 물량이 많을 경우 배송이 지연되는 점 양해 부탁드립니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 상품 준비 도중 시스템 오류나 제품상 문제로 인해 상품의 발송이 지연되거나 품절이 될 수 있습니다.</p>
        <p class="text-red-1"><span style="font-size: 10px;">●</span> 휴일(주말/공휴일 포함) 주문 건은 다음 영업일에 상품 준비 후 발송됩니다.</p>
        `,
      },
      {
        id: 6,
        question:
            '상품 분실, 오배송, 손상된 상품 또는 누락된 상품은 어떻게 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 앱/웹 우측 하단 채널톡 &gt; 배송 문의 &gt; 기타 배송 문의로 문의 주시면 확인 후 처리 도와드리겠습니다.</p>
        고객지원센터 (02-541-0854)
        `,
      },
      {
        id: 7,
        question: '결제 완료 후 주문 내역에 주문 건이 없어요',
        answer: `
        <p><span style="font-size: 10px;">●</span> 결제 완료 후 주문 건 확인이 되지 않으실 경우 고객지원센터로 연락 주시면 신속하게 처리 도와드리겠습니다.</p>
        고객지원센터 (02-541-0854)
        `,
      },
      {
        id: 8,
        question: '결제를 했는데 주문이 취소가 되었어요',
        answer: `
        <p><span style="font-size: 10px;">●</span> 소량 재고 제품 주문 시 동시 주문에 의해 자동으로 주문이 취소될 수 있습니다.</p>
        <p><span style="font-size: 10px;">●</span> 사전 통보 없이 취소될 수 있는 점 양해 부탁드립니다.</p>
        `,
      },
    ],
  },
  {
    id: 2,
    title: '교환 및 반품',
    faqs: [
      {
        id: 1,
        question: '교환 신청은 어떻게 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 교환의 경우, 동일 제품 동일 색상에 한하여 사이즈 변경으로만 가능하며 제품을 공급받으신 날로부터 7일 이내 온라인 사이트를 통하여 교환 신청 부탁드립니다.</p>
        <p><span style="font-size: 10px;">●</span> 마이페이지> 전체 주문 내역 > 해당 주문서 주문번호 선택 > 제품 선택 > 교환 신청 > 교환 사유 : 사이즈 변경 > 원하시는 사이즈 선택 > 배송비 결제 및 교환 신청</p>
        <p><span style="font-size: 10px;">●</span> 영업일 기준 2~3일 이내에 수거 기사님께서 방문하실 예정이며 기사님 연락받으신 후 제품 인계 부탁드립니다.</p>
        <p><span style="font-size: 10px;">●</span> 제품과 택에 손상이 없는 상태로 제품 패킹 부탁드리며 추후 저희 쪽으로 제품 도착 후 교환 처리 도와드릴 예정이나 교환 처리 시점 품절로 인하여 교환이 불가할 경우 고객님께 유선상 안내 도와드리겠습니다.</p>
        `,
      },
      {
        id: 2,
        question: '반품 신청은 어떻게 하나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 반품의 경우, 제품을 공급받으신 날로부터 7일 이내 온라인 사이트를 통하여 반품 신청 부탁드립니다.</p>
        <p><span style="font-size: 10px;">●</span> 마이페이지 > 전체 주문 내역 > 해당 주문서 주문번호 선택 > 제품 선택 > 반품 신청 > 사유 기재 > 배송비 결제 및 반품 신청</p>
        <p><span style="font-size: 10px;">●</span> 영업일 기준 2~3일 이내에 수거 기사님께서 방문하실 예정이며 기사님 연락받으신 후 제품 인계 부탁드립니다.</p>
        <p><span style="font-size: 10px;">●</span> 제품과 택에 손상이 없는 상태로 제품 패킹 부탁드리며 추후 저희 쪽으로 제품 도착 후 빠른 환불 처리 도와드리겠습니다.</p>
        `,
      },
      {
        id: 3,
        question: '교환/반품 신청을 했는데 택배 수거가 안돼요',
        answer: `
        <p><span style="font-size: 10px;">●</span> 교환/환불 신청 후 영업일 기준 2~3일 이내 택배 기사님이 방문하실 예정입니다.</p>
        <p><span style="font-size: 10px;">●</span> 필요시 기사님께서 직접 고객님께 연락을 드릴 수 있습니다.</p>
        `,
      },
      {
        id: 4,
        question: '반품을 수거해갔는데 언제 환불이 되나요?',
        answer: `
        <p><span style="font-size: 10px;">●</span> 반품 상품이 본사에 입고되면 순차적으로 상품 검수 후 이상이 없는 경우에만 환불이 진행됩니다. (토, 일 및 공휴일 제외)</p>
        <p><span style="font-size: 10px;">●</span> 반품 물량이 많을 경우 환불 처리에 지연이 발생할 수 있습니다. 순차적으로 상품 검수 후 빠른 처리 도와드리겠습니다.</p>
        <p><span style="font-size: 10px;">●</span> 금액 환불의 경우 환불 처리 완료 후 은행사의 상황에 따라 3~5일 정도 소요되는 점 참고 부탁드립니다.</p>
        `,
      },
      {
        id: 5,
        question: '교환/반품 신청이 안돼요',
        answer: `
        <p><span style="font-size: 10px;">●</span> 구매확정 시 교환/반품 신청은 불가합니다.</p>
        <p><span style="font-size: 10px;">●</span> 신청 취소로 인하여 재신청이 불가하실 경우 앱/웹 우측 하단 채널톡으로 문의 주시면 신속하게 처리 도와드리겠습니다.</p>
        고객지원센터 (02-541-0854)
        `,
      },
    ],
  },
  {
    id: 3,
    title: '계정 관련',
    faqs: [
      {
        id: 1,
        question: '내 정보를 수정하고 수정하기 버튼이 안 눌러져요',
        answer: `<p>내 정보 수정 변경 시 빈칸 없이 모두 기재하셔야 수정이 가능합니다.</p>`,
      },
      {
        id: 2,
        question: '계정 아이디를 변경하고 싶어요',
        answer: `<p><span style="font-size: 10px;">●</span> 아이디는 수정이 불가능하며 탈퇴 후 재가입을 하셔야 가능합니다.</p>
                 <p class="text-red-1"><span style="font-size: 10px;">●</span> 계정 탈퇴 시 쿠폰 및 적립금은 재발급이 불가능하니 참고 부탁드립니다.</p>
        `,
      },
      {
        id: 3,
        question: '비밀번호를 변경하고 싶어요',
        answer: `<p>로그인 페이지 화면에서 비밀번호 변경이 가능합니다.</p>`,
      },
      {
        id: 4,
        question: '기존 배송지를 변경하고 싶어요',
        answer: `<p>기존 배송지 변경은 마이페이지 > 내 정보 수정 > 배송지 목록 > 변경 원하시는 주소 선택 > 기존 배송지가 설정된 상태에서 주소 변경하여 수정하기 클릭</p>`,
      },
      {
        id: 5,
        question: '앱 푸시 알림 거부하고 싶어요',
        answer: `<p><span style="font-size: 10px;">●</span> 마이페이지 > 내 정보 수정 > 마케팅 정보 수신 동의 > PUSH, SMS 체크 해제</p>
                 <p><span style="font-size: 10px;">●</span> 휴대폰 설정에서 해당 앱 알림 끄기</p>`,
      },
    ],
  },
  {
    id: 4,
    title: '제품 관련',
    faqs: [
      {
        id: 1,
        question: '품절된 제품 또는 사이즈에 대해 재입고 예정을 알고싶어요',
        answer: `<p>품절된 제품 또는 사이즈에 대한 재입고는 상품마다 재입고 여부 및 일정이 상이하므로 정확한 안내는 어려운 점 양해 부탁드립니다. 추후 사이트 확인 후 구매 부탁드립니다.</p>
                 `,
      },
      {
        id: 2,
        question: '사이즈 추천해 주세요',
        answer: `<p>온라인 스토어 특성상 자세한 사이즈 추천이 어려운 점 양해 부탁드립니다. 상품 페이지에서 사이즈 가이드 참고 부탁드립니다.</p>
                 `,
      },
      {
        id: 3,
        question: '제품 정보는 어떻게 확인하나요?',
        answer: `<p>상품 페이지에서 상품 정보 고시로 확인이 가능합니다.</p>`,
      },
    ],
  },
  {
    id: 5,
    title: '고객지원',
    faqs: [
      {
        id: 1,
        question: '고객지원팀에 연락하는 방법을 알려주세요',
        answer: `
        <p>앱/웹 우측 하단 채널톡 문의 또는 고객지원센터로 연락 주시면 확인 후 처리 도와드리겠습니다.</p>
        <p>운영시간 : am 09:30 – pm 05:30 (토, 일 및 공휴일 휴무)</p>
        <p>점심시간 : pm 12:30 – pm 01:30</p>
        <p>고객지원센터 : 02-541-0854</p>
        `,
      },
    ],
  },
  {
    id: 6,
    title: 'A/S 지원',
    faqs: [
      {
        id: 1,
        question: 'A/S는 어떻게 신청해야 하나요?',
        answer: `<p><span style="font-size: 10px;">●</span> 앱/웹 우측 하단 채널톡 > 불량 및 A/S로 문의 주시면 확인 후 처리 도와드리겠습니다.</p>
                 <p class="text-red-1"><span style="font-size: 10px;">●</span> 자세한 A/S 안내는 사이트 하단 문의하기 > A/S 안내 확인 부탁드립니다.</p>`,
      },
    ],
  },
];

export default FAQ_DATA;
